export default function AudreyHack({ children }: { children: string }) {
  return <div style={{ marginTop: 6 }}>{children}</div>
}
